import { defineComponent, computed, createVNode } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import { getStyle, getFixedCls } from "./utils.js";
import { getValueByPath } from "../_utils/get-value-by-path.js";
var _Td = defineComponent({
  name: "Td",
  props: {
    isSorted: {
      type: Boolean
    },
    rowIndex: Number,
    record: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: "normal"
    },
    operations: {
      type: Array,
      default: () => []
    },
    dataColumns: {
      type: Array,
      default: () => []
    },
    colSpan: {
      type: Number,
      default: 1
    },
    rowSpan: {
      type: Number,
      default: 1
    },
    isFixedExpand: {
      type: Boolean,
      default: false
    },
    containerWidth: {
      type: Number
    },
    showExpandBtn: {
      type: Boolean,
      default: false
    },
    indentSize: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("table");
    const style = computed(() => getStyle(props.column, {
      dataColumns: props.dataColumns,
      operations: props.operations
    }));
    const cls = computed(() => {
      var _a, _b;
      return [`${prefixCls}-td`, `${prefixCls}-td-align-${(_b = (_a = props.column) == null ? void 0 : _a.align) != null ? _b : "left"}`, {
        [`${prefixCls}-col-sorted`]: props.isSorted
      }, ...getFixedCls(prefixCls, props.column)];
    });
    const cellStyle = computed(() => {
      if (props.isFixedExpand && props.containerWidth) {
        return {
          width: `${props.containerWidth}px`
        };
      }
      return void 0;
    });
    const renderContent = () => {
      var _a, _b;
      if (slots.default) {
        return slots.default();
      }
      if (props.column.render) {
        return props.column.render({
          record: props.record,
          column: props.column,
          rowIndex: (_a = props.rowIndex) != null ? _a : -1
        });
      }
      return String((_b = getValueByPath(props.record, props.column.dataIndex)) != null ? _b : "");
    };
    return () => {
      var _a, _b;
      return createVNode("td", {
        "class": cls.value,
        "style": style.value,
        "colspan": props.colSpan > 1 ? props.colSpan : void 0
      }, [createVNode("span", {
        "class": [`${prefixCls}-cell`, {
          [`${prefixCls}-cell-fixed-expand`]: props.isFixedExpand,
          [`${prefixCls}-cell-text-ellipsis`]: (_a = props.column) == null ? void 0 : _a.ellipsis
        }],
        "style": cellStyle.value
      }, [props.indentSize > 0 && createVNode("span", {
        "style": {
          paddingLeft: `${props.indentSize}px`
        }
      }, null), props.showExpandBtn && createVNode("span", {
        "style": {
          display: "inline-flex",
          marginRight: "6px"
        }
      }, [(_b = slots.expandBtn) == null ? void 0 : _b.call(slots)]), renderContent()])]);
    };
  }
});
export { _Td as default };
